
import styled from 'styled-components';

export const QueryListStyle = styled.ul`
  background-color: "yellow";
  display: inline-block;
  list-style-type: none;
  padding: 0px;
  margin-bottom: 0px;
  vertical-align: top;
`
